<template>
	<div class="AppHeading bottom-24">
		<div class="container">
			<div class="row">
				<div class="col">
					<h2 class="AppHeading__title">{{ title }}</h2>

					<div
						v-if="isButton || subtitle"
						class="AppHeading__wrapper"
					>
						<button
							v-if="isButtonCondition"
							class="AppHeading__button"
							@click="isClicked()"
						>
							<BackIcon />
						</button>

						<h3 class="AppHeading__subtitle">{{ subtitle }}</h3>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'title',
		'subtitle',
		'isButton',
		'isButtonCondition',
	],

	components: {
		BackIcon: () => import('../assets/images/back.svg'),
	},

	methods: {
		isClicked() {
			this.$emit('isButtonClicked')
		},
	},
}
</script>

<style lang="scss" scoped>
	.AppHeading {
		&__title,
		&__subtitle {
			font-size: 24px;
			line-height: 29px;
			margin-bottom: 0;
		}

		&__title {
			color: #474747;
		}

		&__wrapper {
			display: flex;
		}

		&__subtitle {
			color: #B5B5B5;
		}

		&__button {
			background: transparent;
			border: none;
			width: 30px;
			margin-left: -6px;
			display: flex;
			align-items: center;

			svg {
				transform: scale(0.85);
			}

			svg path {
				fill: $blue;
			}
		}
	}
</style>
